<template>
  <section class="bg-black overflow-hidden">
    <div class="bg-black flex sm:flex-col page-container">
      <div class="w-1/2 sm:w-full">
        <div data-aos="fade-left" class="pt-48 sm:pt-0 sm:w-4/5 sm:m-auto">
          <div class="about-title text-5xl xl:text-4xl lg:text-3xl sm:text-2xl">THERE IS NO LIMIT IN PERFECTING A CRAFT</div>
          <div class="about-content text-lg xl:text-base lg:text-base w-3/5 sm:w-full sm:text-lg">
            We pursuit the art of creation and bring forth new ideas. The
            discovery of new flavors and ingredients. To keep up with time for
            all the new ideas, keep within time for the skills and tradition.To
            provide an experience that now we can consider exceptional.
          </div>
        </div>
      </div>
      <div class="w-1/2 pl-20 sm:pl-0 sm:w-full">
        <img
          :src="require('../assets/About/nigiri.png')"
          alt=""
          data-aos="fade-up"
          class="float-right"
        />
      </div>
    </div>

    <div class="bg-black w-full flex sm:flex-col page-container">
      <div class="bg-black flex sm:flex-col-reverse pt-48 sm:py-20">
        <div class="w-1/2 sm:w-full">
          <img
            :src="require('../assets/About/fish-flower.jpg')"
            alt=""
            data-aos="fade-up"
          />
        </div>
        <div class="w-1/2 sm:w-full">
          <div data-aos="fade-left" class="pl-20 3xl:pl-40 2xl:pl-30 sm:pl-8">
            <div class="about-content-bottom float-right text-lg xl:text-base lg:text-base">
              Doing things out of the ordinary, we get our fish from head to
              tail, present you the freshest quality cut and avoid all
              unnecessary smell and flavor.
              <br />
              <br />
              <br />
              Foreseeing great expansion and developments in this community,
              Sushi Shogun believes that greater future comes from growing
              together. We believe in giving back to the community as a way to
              show our appreciation.
            </div>

            <div class="w-1/3 float-right pt-48 pr-42 sm:hidden">
              <img
                :src="require('../assets/About/get-direction.png')"
                alt=""
                data-aos="fade-up"
              />
            </div>
            <div class="w-full about-title text-3xl clear-both pt-30 sm:hidden">VISIT US TODAY</div>
          </div>
        </div>
      </div>

      <div class="w-full float-right pt-48 pr-42 sm:pt-8 sm:px-8 hidden sm:inline-block">
              <div class="w-2/3 about-title text-3xl sm:text-lg pt-80 sm:pt-8 hidden sm:inline-block">VISIT US TODAY</div>
              <img
                :src="require('../assets/About/get-direction.png')"
                alt=""
                class="w-1/3 float-right"
                data-aos="fade-up"
              />
            </div>
            

    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.about-title {
  font-family: Times;
  font-style: normal;
  font-weight: normal;

  /* or 109% */

  letter-spacing: 0.05em;
  text-transform: uppercase;

  /* white */

  color: #ffffff;
}
.about-content {
  font-family: avenirLight;
  font-style: normal;
  font-weight: normal;

  /* or 133% */
  padding-top: 15%;
  letter-spacing: 0.05em;

  /* white */

  color: #ffffff;
}
.about-content-bottom {
 font-family: avenirLight;
  font-style: normal;
  font-weight: normal;

  /* or 133% */
  width: 100%;
  padding-top: 15%;
  letter-spacing: 0.05em;

  /* white */

  color: #ffffff;
}
@media only screen and (max-width:639px)
{
  .page-container
  {
    max-width:100%;
  }
}
@media only screen and (min-width: 1535px) and (max-width: 1920px) 
{
  .about-content-bottom
  {
    width:548px;
  }
}
</style>